import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import CanvassBattlePlanDetailsScreen from '@/components/CanvassBattlePlanDetailsScreen';

export default function BattlePlanDetailsScreen() {
  const { battlePlanId } = useLocalSearchParams<{ battlePlanId: string }>();

  return <CanvassBattlePlanDetailsScreen battlePlanId={battlePlanId} />;
} 